// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Kx23f","label":"Category_label__3z9b7","content":"Category_content__1RE51","header":"Category_header__3dYXU","location":"Category_location__Jq7q2"};